import {Component} from '@angular/core';
import {DataUnitSetupCatalogStatus} from '@domain/data-unit-setup/data-unit-setup-catalog-status.enum';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
  templateUrl: './data-unit-setup-catalog-overview-status.component.html',
  styleUrls: ['./data-unit-setup-catalog-overview-status.component.scss']
})
export class DataUnitSetupCatalogOverviewStatusComponent implements ICellRendererAngularComp {
  private dataUnitSetupCatalogStatus: DataUnitSetupCatalogStatus;

  public getIconNameForDataUnitSetupCatalogStatus(): string {
    return DataUnitSetupCatalogStatus.getStatusIconName(this.dataUnitSetupCatalogStatus);
  }

  public isCancelledIcon(): boolean {
    return this.dataUnitSetupCatalogStatus === DataUnitSetupCatalogStatus.REJECTED;
  }

  public agInit(params: ICellRendererParams): void {
    this.dataUnitSetupCatalogStatus = params.value;
  }

  public refresh(params: any): boolean {
    return false;
  }
}
